// extracted by mini-css-extract-plugin
export default {"modalPosition":"ModalForm_modalPosition__QMVD+"};